/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum EnvEnum {
  dev = 'Development',
  prod = 'Production',
}

export const env: EnvEnum =
  process.env.NODE_ENV == 'development' ? EnvEnum.dev : EnvEnum.prod;

const AppSettings = {
  auth: {
    access: {
      name: 'accessToken',
      durationDays: 24 / 1,
    },
    refresh: {
      name: 'refreshToken',
      durationDays: 30,
    },
  },
  api: {
    // Задаётся в .env.development (yarn start → localhost) и .env.production
    // (yarn build → прод). Для разовой подмены — .env.development.local.
    url: process.env.REACT_APP_API_URL || 'http://localhost:3017',
  },
};

export { AppSettings };
